import axios from "axios";

//Constants
const SET_DIET_DIARY_MENU_ITEMS = "SET_DIET_DIARY_MENU_ITEMS";
const LOGOUT = "LOGOUT";

//Acessors
const getDietMenuItems = (state) => state?.dietMenuItems;
const getParticipantDateOfEnrollment = (state) =>
  state?.smartPageHeaderReducer?.participantDateOfEnrollment;

//Default state
const initialState = {
  dietMenuItems: null,
};

export const dietDiaryMenuItemsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DIET_DIARY_MENU_ITEMS: {
      const { dietMenuItems } = action;

      return Object.assign({}, state, {
        dietMenuItems: dietMenuItems,
      });
    }
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

//Mutators
const fetchDietDiaryMenuItems = () => (dispatch) => {
  return axios.get(`/api/dietmenu`).then(({ data }) => {
    dispatch({ type: SET_DIET_DIARY_MENU_ITEMS, dietMenuItems: data });
  });
};

export const mapStateToProps = (state) => {
  return {
    dietMenuItems: getDietMenuItems(state),
    participantDateOfEnrollment: getParticipantDateOfEnrollment(state),
  };
};

export const mapDispatchToProps = {
  fetchDietDiaryMenuItems,
};
